// The dashboard chart palette. CSS owns the theme via :root in styles.css; chart.js draws on a
// canvas and cannot read CSS custom properties, so the radar, line and bar charts take these
// canvas-safe values instead. There is one palette: colour is not chosen per brand.
export const chartPalette = {
    '--primary': '#d5490b',
    '--primary-opaque-25': 'rgba(213, 73, 11, 0.25)',
};
